module.exports = __webpack_public_path__ + "img/s_10.2ae49cbe.png";